import videojs from 'video.js';
import isAutoplayAllowed from './components/modules/autoplay-allowed';

window.videojs = videojs;

function whenIdleAfterLoad(callback) {
  const onIdle = () => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, { timeout: 3000 });
    } else {
      window.setTimeout(callback, 200);
    }
  };

  if (document.readyState === 'complete') {
    onIdle();
    return;
  }

  EventTarget.prototype.addEventListener.call(window, 'load', onIdle, { once: true });
}

whenIdleAfterLoad(() => {
  // without autoplay the player isn't created: nothing is downloaded and the poster image stays
  if (!isAutoplayAllowed()) {
    return;
  }

  document.querySelectorAll('video-js[data-play-after-load]').forEach((el) => {
    const player = videojs(el);

    player.ready(() => {
      const playing = player.play();

      if (playing) {
        playing.catch(() => {});
      }
    });
  });
});
